exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".approveColorResultMsg{margin-bottom:4px;display:inline-block}.download-file{cursor:pointer;color:#ff8850}.mt-8{margin-top:8px}\n", ""]);

// exports
